export default function SystemMessage({ children }: { children: React.ReactNode }) {
  return (
    <div
      className="app-anim-fade-left-d100"
      style={{
        maxWidth: 384,
        padding: "4px 0",
        fontFamily: "var(--font-urbanist), sans-serif",
        fontWeight: 500,
        fontSize: 16,
        lineHeight: "26px",
        color: "rgba(242,240,237,0.5)",
      }}
    >
      {children}
    </div>
  );
}
